import { MdsLink, MDSSection, MDSSectionSlotName } from "@/mds";
import { IntegrationsSenderItemList } from "@/pages/integrations/shared/integrations-list";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC } from "react";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { useAppStore } from "@/store";
import { windowModule } from "@/modules/window";
import { IntegrationsLoader } from "@/pages/integrations/shared/integrations-loader";
import {
  StyledContentList,
  StyledContentSectionTitleWrapper,
  StyledContentStatusWrapper,
  StyledContentWrapper,
} from "@/pages/integrations/shared/integrations.styles";
import { IntegrationsLayoutBottomBuffer } from "@/pages/integrations/shared/integrations-layout";

export const IntegrationsEmailPageContent: FC = observer(() => {
  const { store } = useAppStore();
  const { verifiedItems, isLoading } = store.emailSenders;
  const isConnected = verifiedItems.length > 0;

  return (
    <StyledContentWrapper>
      <MDSSection
        title={
          <StyledContentSectionTitleWrapper>
            <MdsIcon kind={MdsIconKind.Envelope} />
            Email Integration
          </StyledContentSectionTitleWrapper>
        }
      >
        <div slot={MDSSectionSlotName.HeaderRightAddon}>
          {isConnected && (
            <StyledContentStatusWrapper>
              Connected
              <MdsIcon kind={MdsIconKind.CheckCircleSolid} />
            </StyledContentStatusWrapper>
          )}
        </div>
        <StyledContentList>
          <li>
            Forward anything—try travel confirmations, lengthy newsletters, customer
            correspondences, and whatever else you want to remember!—from a verified email to{" "}
            <EmailHighlight
              onPress={() => windowModule.openInNewTab({ url: new URL("mailto:save@mem.ai") })}
            >
              save@mem.ai
            </EmailHighlight>
          </li>
          <li>
            Mem will automatically clean and summarize any email or email thread into a structured,
            organized note
          </li>
          <li>The original email will be attached to the note for your reference</li>
        </StyledContentList>
      </MDSSection>
      {isLoading ? <IntegrationsLoader /> : <IntegrationsSenderItemList itemKind="email" />}
      <IntegrationsLayoutBottomBuffer />
    </StyledContentWrapper>
  );
});

const EmailHighlight = styled(MdsLink)(({ theme }) => ({
  fontWeight: theme.fontWeights.medium,
}));
